import { Arr } from '@deqo/foundation';
import { GeomUtil } from '../../../platform/geom/GeomUtil';
import { toRadians } from '../../../platform/geom/Math';
import { Point } from '../../../platform/geom/Point';
import { Polyline } from '../../../platform/geom/Polyline';
import { Plot } from '../layout/Plot';

const InsertPoint = (position: Point, vector: Point) => ({ position, vector });
type InsertPoint = ReturnType<typeof InsertPoint>;

const insertPointsFromHull = (hull: Polyline) => {

    const result = [] as InsertPoint[];
    // if (convexHull.length < 3) return convexHull;

    for (const { p1, p2 } of hull.lines) {
        if (p1.x === p2.x || p1.y === p2.y) {
            continue;
        }

        const p3 = new Point(p2.x, p1.y);
        const p4 = new Point(p1.x, p2.y);

        const pX = GeomUtil.nearestPointTo(hull.center, [p3, p4]);
        const pV = Point.vector(pX, p1).rotate(toRadians(45)).normalize();

        result.push(InsertPoint(pX, pV));
    }

    return result;
};

export class Squash {

    private plots = [] as Plot[];

    constructor(private initial: Plot) {
        this.plots.push(initial);
    }

    public add(next: Plot) {

        // await waitFor(100);

        const insert = this.plots.length === 1
            ? this.getInsertPointForFirstAdd()
            : this.getInsertPointForNextAdd();

        // DebugOverlay.point(uuid(), insert.position, 'green', 10);

        if (!insert) return;

        next.centerTo(insert.position.x, insert.position.y);
        // DebugOverlay.rect((next as any).subject.id, next.bounds(), 'gold');

        for (let cb = 0; cb < 1000; cb++) {
            // While intersecting any other plot, move away from the center
            if (this.isIntersecting(next)) {
                const mv = insert.vector.multiply(10);
                next.moveBy(mv.x, mv.y);
                // DebugOverlay.rect((next as any).subject.id, next.bounds(), 'gold');

            }
            else {
                break;
            }
        }

        for (const a of this.plots) {
            // DebugOverlay.rect((a as any).subject.id, a.bounds(), 'gold');
        }

        // DebugOverlay.rect((next as any).subject.id, next.bounds(), 'red');

        this.plots.push(next);

        // for (const ins of inserts) {
        //     DebugOverlay.point(uuid(), ins.position, 'red');
        //     DebugOverlay.line(uuid(), new Line(ins.position, ins.position.add(ins.vector.multiply(50))), 'red');
        // }
    }

    public apply() {
        for (const plot of this.plots) {
            plot.apply();
        }
    }

    private getInsertPointForFirstAdd() {
        // If just one, choose a random edge and take the mid point
        const bounds = this.initial.bounds();
        const edge = Arr.random([
            bounds.lines()[0],
            bounds.lines()[2],
        ]);
        return InsertPoint(
            edge.mid,
            edge.normal,
        );
    }

    private getInsertPointForNextAdd() {

        for (const a of this.plots.flatMap(x => x.bounds().points())) {
            // await waitFor(100);
            // DebugOverlay.point(uuid(), a, 'purple');
        }

        const hull = Polyline.fromHull(
            this.plots.flatMap(x => x.bounds().points())
        );

        // DebugOverlay.polyline(uuid(), hull.points, 'blue', true);

        // await waitFor(100);

        const options = insertPointsFromHull(hull);
        for (const ins of options) {
            // DebugOverlay.point(uuid(), ins.position, 'red');
            // DebugOverlay.line(uuid(), new Line(ins.position, ins.position.add(ins.vector.multiply(50))), 'red');
        }

        // Find the nearest point to the center of the initial plot
        const center = this.initial.center();
        return GeomUtil.nearestTo(center, options, x => x.position);
    }

    private isIntersecting(plot: Plot) {
        // Check if the plot is intersecting any other plot
        for (const p of this.plots) {
            if (p === plot) continue;
            if (p.bounds().inflate(20).intersects(plot.bounds())) {
                // DebugOverlay.rect('aaa', plot.bounds(), 'teal');
                // DebugOverlay.rect('bbb', p.bounds(), 'teal');
                return true;
            }
        }
        return false;
    }
}
